import {
  Logout,
  FetchMCsCounts,
  FetchMCCustomers,
  FetchMCsWithPendingRequests,
} from 'src/constants/actionTypes'
import { Action } from 'src/utils/reduxUtils'
import { MCState } from './types'

const getInitialState = (): MCState => ({
  mcCounts: null,
  mcCustomers: [],
  mcsWithPendingRequests: [],
})

export const mcReducer = (state: MCState = getInitialState(), action: Action<any>): MCState => {
  switch (action.type) {
    case FetchMCsCounts.type.SUCCESS:
      return {
        ...state,
        mcCounts: action.payload,
      }
    case FetchMCCustomers.type.SUCCESS:
      return {
        ...state,
        mcCustomers: action.payload.data,
      }
    case FetchMCsWithPendingRequests.type.SUCCESS:
      return {
        ...state,
        mcsWithPendingRequests: action.payload,
      }
    case Logout.type.SUCCESS:
      return getInitialState()
    default:
      return state
  }
}
